// AUTO-GENERATED by asyncapi-cable from the cable AsyncAPI documents.
// Do not edit by hand — regenerate with the asyncapi-cable CLI.

import { Channel } from "@anycable/core";
import type { AnnouncementMessage } from "../models/AnnouncementMessage";

/** Alternatives declared for the operation — AsyncAPI treats a channel's messages as a union. */
export type NotificationsData = AnnouncementMessage;

/** Params the client supplies at subscribe time. */
export type NotificationsParams = Record<string, never>;

export class NotificationsChannel extends Channel<NotificationsParams, NotificationsData> {
  static identifier = "NotificationsChannel";
}
